<script>
import DocumentListComponent from "./components/resources/DocumentListComponent.vue";
import AutoriryComponent from "./components/resources/AutoriryComponent.vue";
import NewsComponent from "./components/resources/NewsComponent.vue";
import ITCGridComponent from "./components/resources/ITCGridComponent.vue";
import BoxIconGridComponent from "./components/resources/BoxIconGridComponent.vue";
import MultiSliderComponent from "./components/resources/MultiSliderComponent.vue";
import FrecuentAccessComponent from "./components/resources/FrecuentAccessComponent.vue";
import GridLinkComponent from "./components/resources/GridLinkComponent.vue";
import CardGridComponent from "./components/resources/CardGridComponent.vue";
import ExpedientesComponent from "./components/resources/ExpedientesComponent.vue";

export default {
  name: "HomeView",
  components: {
    /* eslint-disable */
    DocumentListComponent,
    /* eslint-disable */
    AutoriryComponent,
    /* eslint-disable */
    NewsComponent,
    /* eslint-disable */
    ITCGridComponent,
    /* eslint-disable */
    BoxIconGridComponent,
    /* eslint-disable */
    MultiSliderComponent,
    /* eslint-disable */
    FrecuentAccessComponent,
    /* eslint-disable */
    GridLinkComponent,
    /* eslint-disable */
    CardGridComponent,
    /* eslint-disable */
    ExpedientesComponent,
  },
  data() {
    return {
      site: 20,
    };
  },
  mounted() {
    document.title = process.env.VUE_APP_TITLE;
  },
};
</script>
<!-- BOTONES -->
<template>
  <ITCGridComponent
    :columnas="2"
    titulo=""
    :data="[
      {
        desc: null,
        icon: 'ptn-i-documento',
        target: '_self',
        title: 'Consulta de expedientes',
        url: '?uid=CUMV-VIEW-ExpedientesComponent',
      },
      {
        desc: null,
        icon: 'question_answer',
        target: '_self',
        title: 'Consultas y solicitudes',
        url: '?uid=CUMV-VIEW-FormComponent',
      },
    ]"
  />

  <div class="container">
    <div class="row">
      <div class="col-md-6">
        <DocumentListComponent
          resultados="5"
          :show-fecha="false"
          titulo="Guía de Trámites"
          :filtros="{ site: this.site }"
        />
      </div>
      <div class="col-md-6">
        <DocumentListComponent
          resultados="5"
          :show-fecha="false"
          titulo="Boletín Oficial"
          :filtros="{ site: 21 }"
        />
      </div>
      <div class="col-md-12">
        <CardGridComponent
          columnas="1"
          :data="[
            {
              target: '_self',
              title: 'Licitaciones',
              url: 'https://licitaciones.sanjuan.gob.ar/',
            },
          ]"
        />
      </div>
    </div>
  </div>

  <NewsComponent titulo="Noticias" class="pb-3" />

  <!--   <BoxIconGridComponent
    titulo="¿Cómo me contacto?"
    :filtros="{ site: this.site }"
  /> -->

  <AutoriryComponent
    :showProtocolo="false"
    :showLinks="true"
    :data="[
      {
        title: 'Emilio Achem',
        subtitle: 'Secretario General de la Gobernación',
        imagen: require('@/assets/img/secretaria-gobierno.jpg'),
      },
    ]"
  />
</template>
